import React from 'react'
import Button from '../../atoms/Button'

import * as style from './style.module.scss'

const CreateInvoiceCta = () => (
    <div className={style.wrap}>
        <p className={style.title}>Create a high quality invoice now!</p>
        <Button large newPage to="https://app.invoicemaker.com/">
            Make an Invoice Now
        </Button>
    </div>
)

export default CreateInvoiceCta
